import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 51.498 51.498",
  fill: "#fff"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "Group_4232",
  "data-name": "Group 4232",
  transform: "translate(-2 -2)",
  class: "cls-1"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_8037",
    "data-name": "Path 8037",
    class: "cls-1",
    d: "M31.178 37.178H4.918v-26.26h14.589V8H4.918A2.918 2.918 0 0 0 2 10.918v26.26A2.918 2.918 0 0 0 4.918 40.1h26.26a2.918 2.918 0 0 0 2.922-2.922V22.589h-2.922Z",
    transform: "translate(0 2.753)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_8038",
    "data-name": "Path 8038",
    class: "cls-1",
    d: "M34.883 2H20.294v2.918h12.532L13 24.744l2.057 2.056L34.883 6.975v12.532H37.8V2Z",
    transform: "translate(5.048)"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };